export enum CallHistoryAction {
    Initiated = 1,
    Ringing = 2,
    InProgress = 3,
    Completed = 4,
    NoAnswer = 5,

    PopupShown = 100,
    ProfileOpened = 101,
    PopupDismissed = 102,
    PopupTimeout = 103,
    PopupQuantityLimit = 104
}

export type CallHistoryReportRequest = {
    branchId: number
    callSid: string
    customerUserId: number
    masterAccountId: number
    action: CallHistoryAction
}

export type Branch = {
    id: number
    externalId: string
    phoneNumber: string
    hasJiveFeature: boolean
    phoneCallEnabled?: boolean
    hasPhone1Feature: boolean
}

export type CallDirection = "Inbound" | "Outbound";